<template>
  <!-- one person in a list of who favorited, repeated, reacted or quoted -->
  <router-link
    :to="profileLink(user)"
    class="user-list-row"
  >
    <UserAvatar
      :user-id="user.id"
      class="avatar-small"
      :compact="true"
    />
    <div class="user-list-names">
      <NameWithEmoji
        class="username"
        :title="'@'+user.screen_name_full_ui"
        :name="displayName(user)"
        :emoji="user.emoji"
      />
      <span class="user-list-screen-name">{{ user.screen_name_ui }}</span><UnicodeDomainIndicator :user="user" />
    </div>
  </router-link>
</template>

<script src="./user_list_row.js"></script>

<style lang="scss">
.user-list-row {
  padding: 0.25em;
  display: flex;
  flex-direction: row;
  color: var(--text);
  text-align: start;

  .user-list-names {
    display: flex;
    flex-direction: column;
    margin-left: 0.5em;
    min-width: 5em;
  }

  .user-list-screen-name {
    font-size: 0.65em;
  }
}
</style>
